<template>
  <b-card>
    <div>
      <b-overlay
        :show="loading"
        spinner-type="grow"
        spinner-variant="primary"
        :variant="`transparent`"
        :opacity="1"
        :blur="`2px`"
        rounded="sm"
      >
        <b-table
          sticky-header="70vh"
          :items="projects"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :busy="loading"
          responsive
          hover
          show-empty
          @row-clicked="toggleDetails"
        >
          <template #empty="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template
            #cell(name)="data"
          >
            <b-form-input
              v-if="data.item.is_new || data.item.edited"
              v-model="data.item.name"
            />
            <span v-else>{{ data.item.name }}</span>
          </template>
          <template
            #cell(client)="data"
          >
            <v-select
              v-if="data.item.is_new || data.item.edited"
              v-model="data.item.client_id"
              single-line
              dir="ltr"
              :options="clientsList"
              label="name"
              :close-on-select="true"
              :reduce="item => item.id"
            />
            <span v-else>{{ data.item.client ? data.item.client.name : '' }}</span>
          </template>
          <template
            #row-details="row"
          >
            <contracts-list
              v-if="!row.item.hasOwnProperty('is_new')"
              :contracts="row.item.contracts"
              :project-id="row.item.id"
              :data-for-select="dataForSelect"
            />
          </template>
          <template #cell(actions)="data">
            <b-form-group
                v-if="!data.item.edited && !data.item.is_new"
            >
              <feather-icon
                  :id="'edit' + data.item.id"
                  key="edit"
                  icon="Edit3Icon"
                  class="mr-50"
                  size="20"
                  @click="data.item.edited = true"
              />
            </b-form-group>
            <b-form-group
              v-if="data.item.is_new || data.item.edited"
            >
              <feather-icon
                v-for="action in confirmActions"
                :id="action.text + data.item.id"
                :key="action.text"
                :icon="action.icon"
                class="mr-50"
                size="20"
                @click="selectAction(action.text, action.icon, data.item)"
              />
            </b-form-group>
          </template>
        </b-table>
      </b-overlay>
      <b-container class="bv-example-row" v-if="projects.length > 0">
        <b-row align="end">
          <b-col
            cols="10"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-0"
              @change="pagination"
            />
          </b-col>
          <b-col
            cols="2"
            align="end"
          >
            <b-form-select
              id="pages"
              size="sm"
              @change="getProjects"
              v-model="perPage"
              :options="perPages"
              value-field="name"
              text-field="name"
            />
          </b-col>
        </b-row>
      </b-container>
      <b-row
        class="d-flex justify-content-center"
      >
        <b-button
          class="rounded"
          variant="primary"
          @click="selectAction('Insert', '+', {})"
        >
          +
        </b-button>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import axiosIns from '@/libs/axios'
import {
  BTable, BRow, VBTooltip, BButton, BFormInput, BFormGroup, BCard, BOverlay, BContainer, BCol, BPagination, BFormSelect,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { analysError } from '@/_helpers/analys_error'
import ContractsList from '@/views/pages/projects/ContractsList.vue'
import axios from 'axios'
import useJwt from '@/auth/jwt/useJwt'
import vSelect from 'vue-select'

export default {
  components: {
    BFormSelect, BPagination, BCol, BContainer,
    BTable,
    BRow,
    ContractsList,
    BButton,
    BFormInput,
    BFormGroup,
    vSelect,
    BCard,
    BOverlay,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      projects: [],
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true,
          tdClass: 'text-center ml-2',
          thClass: 'text-center',
        },
        {
          key: 'client',
          label: 'Client',
          sortable: true,
          tdClass: 'text-center ml-2',
          thClass: 'text-center',
        },
        {
          key: 'tracked_MTD',
          label: 'Tracked MTD',
          tdClass: 'd-flex justify-content-center',
          thClass: 'text-center',
        },
        {
          key: 'tracked_YTD',
          label: 'Tracked YTD',
          tdClass: 'text-center ml-2',
          thClass: 'text-center',
        },
        {
          key: 'tracked_last_30_days',
          label: 'Tracked 30D',
          tdClass: 'text-center ml-2',
          thClass: 'text-center',
        },
        {
          key: 'actions',
          label: 'Actions',
          tdClass: 'text-center ml-2',
          thClass: 'text-center',
        },
      ],
      defaultActions: [
        { icon: 'EditIcon', text: 'Edit' },
        { icon: 'DeleteIcon', text: 'Delete' },
      ],
      confirmActions: [
        { icon: 'CheckIcon', text: 'Confirm' },
        { icon: 'XIcon', text: 'Cancel' },
      ],
      sortBy: 'name',
      sortDesc: false,
      perPage: 10,
      totalRows: 0,
      perPages: [
        {name: 10},
        {name: 25},
        {name: 50},
        {name: 100}
      ],
      currentPage: 1,
      sortDirection: 'asc',
      loading: false,
      comrades: [],
      dataForSelect: {},
      defaultPaymentTypes: [
        'hourly', 'monthly', 'fixed price',
      ],
      emptyProject: {
        name: '',
        client: '',
        status: true,
        tracked_MTD: 0,
        tracked_YTD: 0,
        tracked_last_30_days: 0,
        is_new: true,
      },
      clientsList: [],
    }
  },
  watch: {
    currentPage() {
      this.getProjects()
    },
  },
  beforeMount() {
    this.getProjects()
    this.getClientsList()
    this.getComradesList()
  },
  methods: {
    getClientsList() {
      axios.get(`${process.env.VUE_APP_API_URL}/client`, {
        headers: { Authorization: `Bearer ${useJwt.getToken()}` },
      }).then(response => {
        this.clientsList = response.data.data
      }).catch(error => {
        const errorRes = analysError(error.response)
        const self = this
        errorRes.forEach(value => {
          self.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: value,
              icon: 'CoffeeIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    getComradesList() {
      axios.get(`${process.env.VUE_APP_API_URL}/comrade`, {
        headers: { Authorization: `Bearer ${useJwt.getToken()}` },
      }).then(response => {
        this.comrades = response.data.data
        this.dataForSelect = {
          comrade_name: {
            options: this.comrades,
            label: 'name',
            reduce: item => item,
          },
          payment_type: { options: this.defaultPaymentTypes, reduce: item => item },
        }
      }).catch(error => {
        const errorRes = analysError(error.response)
        const self = this
        errorRes.forEach(value => {
          self.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: value,
              icon: 'CoffeeIcon',
              variant: 'error',
            },
          })
        })
      })
    },
    toggleDetails(item) {
      if (item._showDetails) item._showDetails = false
      else this.$set(item, '_showDetails', true)
    },
    selectAction(actionText, actionIcon, target) {
      switch (actionText) {
        case 'Edit':
          this.$set(target, 'edited', true)
          break

        case 'Confirm':
          if (target.edited) {
            this.update(target)
            break
          }
          this.create(target)
          break

        case 'Cancel':
          if (target.is_new) {
            const index = this.projects.indexOf(target)
            this.projects.splice(index, 1)
          }
          if (target.edited) {
            target.edited = false
            break
          }
          break

        case 'Delete':
          this.delete(target.id)
          break

        case 'Insert':
          this.projects.push({ ...this.emptyProject })
          break

        default:
          console.log('Default')
          break
      }
    },
    create(data) {
      this.loading = true
      axiosIns
        .post(`${process.env.VUE_APP_API_URL}/project`, data)
        .then(response => {
          this.loading = false
          const createdItem = this.projects.find(item => item === data)
          this.$delete(createdItem, 'is_new')
          this.projects[this.projects.indexOf(data)] = { ...response.data.data }
        })
        .catch(error => {
          this.loading = false
          const errorRes = analysError(error.response)
          const self = this
          errorRes.forEach(value => {
            self.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: value,
                icon: 'CoffeeIcon',
                variant: 'error',
              },
            })
          })
        })
    },
    update(data) {
      this.loading = true
      data.updateList = true
      data.edited = false
      let newData = {
        name: data.name,
        client_id: data.client_id,
        status: data.status,
        updateList: true
      }
      axiosIns
          .put(`${process.env.VUE_APP_API_URL}/project/${data.id}`, newData)
          .then(response => {
            this.loading = false
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: response.data.message,
                icon: 'CoffeeIcon',
                variant: 'success',
              },
            })
            this.getProjects()
          })
          .catch(error => {
            this.loading = false
            const errorRes = analysError(error.response)
            const self = this
            errorRes.forEach(value => {
              self.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: value,
                  icon: 'CoffeeIcon',
                  variant: 'error',
                },
              })
            })
          })
    },
    getProjects() {
      axiosIns.get('/project', {
        params: {
          forWorkPool: true,
          per_page: this.perPage,
          skip: (this.currentPage - 1) * this.perPage,
        }
      })
        .then(response => {
          this.projects = response.data.data.projects;
          this.totalRows = response.data.data.total;
        })
        .catch(error => {
          const errorRes = analysError(error.response)
          const self = this
          errorRes.forEach(value => {
            self.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: value,
                icon: 'CoffeeIcon',
                variant: 'error',
              },
            })
          })
        })
    },
    pagination(value) {
      this.currentPage = value
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style>
.vs__dropdown-menu{
  position: fixed !important;
  top: auto !important;
  left: auto !important;
  width: inherit !important;
  overflow-y: auto !important;
  max-height: 200px !important;
}
</style>
